import ApiService from '../global/services/api.service';
import {
  GeofenceCircle,
  GeofenceRequestDTO,
  GeofenceSearchOption,
} from '../geofence/types';
import { ListResponseDTO, MatchingMethod, TableFilterDTO } from '../global';
import QueryBuilder from '../shared/utils/query-builder';
import { ColorLabel } from '../global/components/SFColorPalette';
import { EntityDTO } from '../shared/types';

export interface GeofenceLightDTO extends EntityDTO {
  id: number;
  name: string;
  description: string;
  polygon: Array<[Array<number>]>;
  creatorId: number;
  circle: GeofenceCircle | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: null | string;
  color: ColorLabel;
}

export type GeofenceDTO = GeofenceLightDTO;

class GeofenceService {
  static ENDPOINT = '/geofences';

  static createGeofence(data: GeofenceRequestDTO) {
    return ApiService.post(`${GeofenceService.ENDPOINT}`, data);
  }

  static getGeofences(filters: Partial<TableFilterDTO> = {}) {
    const body = new QueryBuilder()
      .addLimit(filters.limit || 10)
      .addOffset(filters.offset || 0)
      .or({
        field: GeofenceSearchOption.NAME,
        value: filters.search,
        matchingMethod: MatchingMethod.CONTAINS,
      })
      .or({
        field: GeofenceSearchOption.DESCRIPTION,
        value: filters.search,
        matchingMethod: MatchingMethod.CONTAINS,
      });
    return ApiService.post<ListResponseDTO<GeofenceLightDTO>>(
      `${GeofenceService.ENDPOINT}/search`,
      body,
    );
  }

  static deleteGeofence(id: number) {
    return ApiService.delete(`${GeofenceService.ENDPOINT}/${id}`);
  }

  static getGeofenceById(id: number) {
    return ApiService.get<GeofenceDTO>(
      `${GeofenceService.ENDPOINT}/${String(id)}`,
    );
  }

  static updateGeofence(id: number, data: GeofenceRequestDTO) {
    return ApiService.patch(`${GeofenceService.ENDPOINT}/${id}`, data);
  }
}

export default GeofenceService;
